<template>
<section class="view-wrap three-quarters">
	<div class="title-wrap m-b-2 flex align-center space-between wrap">
		<Heading :level="2" :text="`Change your password for ${email}`" />
	</div>
	<p class="m-b-1">
		Enter a new password below to change your password
	</p>
	<UserMessage class="m-t-2" v-if="userFeedback.message" :message-type="userFeedback.type" :message-text="userFeedback.message" />
	<UserMessage class="m-t-2" v-if="resetPassword" message-type="success">
		<template #messageText>
			<p>
				Successfully reset your password. <router-link :to="{name: 'Login'}">Click here to login</router-link> and access your application dashboard.
			</p>
		</template>
	</UserMessage>
	<form @submit.prevent="changePassword" novalidate ref="form">
		<form-field-set>
			<template #legend>
				<legend class="sr-only">Please enter your email address and password</legend>
			</template>
			<template #fields>
				<PasswordField
					name="password"
					ref="password"
					label-text="Password"
					:value="formData.password"
					@emitFieldData="(val) => formData.password = val"
					:validation-rules="[rules.validatePassword]"
					:is-disabled="userFeedback.readonly" />

				<PasswordField
					name="confPassword"
					ref="confPassword"
					label-text="Confirm your password"
					:value="confPassword"
					@emitFieldData="(val) => confPassword = val"
					:validation-rules="[passwordsMatch]"
					:is-disabled="userFeedback.readonly" />
			</template>
		</form-field-set>

		<Button
			class="primary m-t-3"
			button-type="submit"
			text="Change Password"
			loading-text="Submitting"
			:is-disabled="formSubmitting || userFeedback.readonly"
			:is-loading="formSubmitting"
			@btnClick="changePassword" />
	</form>
</section>
</template>

<script>
import { mapActions } from 'vuex';
import { validationRules } from '@/utilities/validationRules';
import { formValidator } from '@/mixins/formValidator';

export default {
	name: 'ResetPasswordView',
	mixins: [formValidator],
	data: () => ({
		formSubmitting: false,
		rules: validationRules,
		confPassword: '',
		formData: {
			password: ''
		},
		resetPassword: false,
		userFeedback: {
			type: null,
			message: null,
			readonly: false
		}
	}),
	computed: {
		token () {
			return this.$route.query.token;
		},
		email () {
			return this.$route.query.email;
		}
	},
	mounted () {
		if (this.email) {
			this.formData.username = this.email;
		}
	},
	methods: {
		changePassword () {
			this.userFeedback = {
				type: null,
				message: null,
				readonly: true
			};
			this.resetPassword = false;
			if (this.isValid(this.$refs.form)) {
				this.formSubmitting = true;
				this.setNewPassword(this.formData).then((res) => {
					if (res && res.data === true) {
						this.resetPassword = true;
						this.userFeedback = {
							readonly: true
						};
					} else {
						this.userFeedback = {
							type: 'error',
							message: 'error encountered resetting your password.'
						};
					}
				}).catch((err) => {
					this.userFeedback = {
						type: 'error',
						message: err.message
					};
				}).finally(() => {
					this.formSubmitting = false;
				}); ;
			} else {
				this.userFeedback = {
					type: 'error',
					message: 'Please provide a password.'
				};
			};
		},
		// Custom validation rule
		passwordsMatch (value) {
			return value === this.formData.password || 'Passwords do not match';
		},
		...mapActions('auth', ['setNewPassword'])
	}
};
</script>
